import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  class: "gst-svg-icon",
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M12 4a8 8 0 1 0 0 16 8 8 0 0 0 0-16Zm-.8 13.6V16h1.6v1.6h-1.6Zm2.5-5.5.8-.7c.8-.8 1-2.2.1-3.5-.7-1-1.9-1.7-3-1.5-1.3.2-2.3 1.1-2.7 2.3-.1.5.2.9.7.9h.2c.3 0 .6-.2.7-.5.2-.8 1-1.3 2-1 .5.1 1 .6 1 1.2.2.5 0 1-.4 1.4l-1 1a3.2 3.2 0 0 0-.9 2.3v.4h1.6l.1-1c.1-.5.4-.9.8-1.3Z",
  fill: "#BDBDBD"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3))
}
export default { render };